var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import { rules } from '../helpers/Validation';
import Field, { FieldType } from '../elements/Field';
let Dataweb = class Dataweb extends Component {
    constructor() {
        super(...arguments);
        this.schema = {
            name: rules().string().max(30),
            surname: rules().string().max(30),
            telephone: rules().string().max(30),
            emails: rules().string().email(),
            aditional: rules().string().max(254),
        };
    }
    render() {
        const { dataweb, onHandleChange } = this.props;
        return (React.createElement(React.Fragment, null,
            React.createElement(Field, { field: {
                    name: 'name',
                    value: dataweb.name,
                    type: FieldType.Text,
                    size: 6,
                    rules: this.schema['name']
                }, onChange: onHandleChange }),
            React.createElement(Field, { field: {
                    name: 'surname',
                    value: dataweb.surname,
                    type: FieldType.Text,
                    size: 6,
                    rules: this.schema['surname']
                }, onChange: onHandleChange }),
            React.createElement(Field, { field: {
                    name: 'email',
                    value: dataweb.email,
                    type: FieldType.Text,
                    size: 6,
                    rules: this.schema['email']
                }, onChange: onHandleChange }),
            React.createElement(Field, { field: {
                    name: 'telephone',
                    value: dataweb.telephone,
                    type: FieldType.Text,
                    size: 6,
                    rules: this.schema['telephone']
                }, onChange: onHandleChange }),
            React.createElement(Field, { field: {
                    name: 'additionalInformation',
                    value: dataweb.additionalInformation,
                    type: FieldType.Text,
                    size: 6,
                    rules: this.schema['additionalInformation']
                }, onChange: onHandleChange })));
    }
};
Dataweb = __decorate([
    observer
], Dataweb);
export default Dataweb;
const DataweB = ({ name, telephone, email, additionalInfo, onHandleChange }) => {
    const schema = {
        name: rules().string().max(30),
        telephone: rules().string().max(30),
        emails: rules().string().email(),
        aditional: rules().string().max(254),
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Field, { field: {
                name: 'name',
                value: name,
                type: FieldType.Text,
                size: 6,
                rules: schema['name']
            }, onChange: onHandleChange }),
        React.createElement(Field, { field: {
                name: 'email',
                value: name,
                type: FieldType.Text,
                size: 6,
                rules: schema['email']
            }, onChange: onHandleChange }),
        React.createElement(Field, { field: {
                name: 'telephone',
                value: name,
                type: FieldType.Text,
                size: 6,
                rules: schema['telephone']
            }, onChange: onHandleChange })));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Dataweb.tsx
// module id = 557
// module chunks = 0